import { http } from "@/plugins/axios";

// 三个对话模式。label 是界面上展示的名字，hint 用于空状态引导。
export const AI_MODES = [
  { value: "consult", label: "课程咨询", hint: "描述培训需求，AI 会逐步追问补全" },
  { value: "recommend", label: "课程推荐", hint: "直接说需求，AI 推荐匹配课程" },
  { value: "search", label: "课程检索", hint: "给出专业类别与关键词，精确找课" },
];

export const MODE_LABEL = AI_MODES.reduce((acc, m) => {
  acc[m.value] = m.label;
  return acc;
}, {});

// 预留：对齐《沃盟AI小盟需求》3.2.2 素材文件上传（本期不启用）
export const ATTACH_ACCEPT = ".pdf,.doc,.docx,.ppt,.pptx,.txt,.md";
export const ATTACH_MAX_SIZE = 100 * 1024 * 1024;

export const AI_INPUT_MAX = 2000;

export default {
  /** 当前登录用户的会话列表 */
  async listSessions() {
    const { data } = await http.get("ai/sessions");
    return data.sessions || [];
  },

  /** 指定会话的消息历史 */
  async getHistory(sessionId) {
    const { data } = await http.get(`ai/sessions/${encodeURIComponent(sessionId)}`);
    return data;
  },

  /** 发送一条消息。sessionId 为 null 时上游会新建会话 */
  async chat({ input, mode, sessionId }) {
    const { data } = await http.post("ai/chat", {
      input,
      mode,
      sessionId: sessionId || null,
    });
    return data;
  },

  /** AI 服务可用性探测；不可用时返回 false 而不抛错 */
  async health() {
    try {
      const { data } = await http.get("ai/health");
      return !!(data && data.available);
    } catch (e) {
      return false;
    }
  },
};
